export const environment = {
  production: true,
  version: "{v0.0.0}",
  hiddenPath: true,
  useHash: true,
  ipServer: 'https://www.vepormas.com/',
  app_path: 'cb-comunes-camel/vepormas/cbm/web/',
  security_path: 'seguridad-camel-cb/comunes/web/',
  websocketUrl: 'cbms-alertas/vepormas/alertas-socket',
  keyGeoApp: 'c2VjX3VzcjI6RDg2QTdFNDBBOURBRTU3RkY2NTQ0QzI1NEMzNEU1NTA=',
  timeReloadFav: 10000, // 10 segundos
  keyBlock: true,
  destroyOnReload: true,
  _s3c: 'YWtRTEtFdHpaalg0NTZJTXpLV0N4dkdET1dVS3MzSGhHZ0pXb0VYRHZMT3NEMDM=',
  serviceWorker: {
    enabled: true, // Habilitado en producción
    updateCheckInterval: 60 * 60 * 1000 // 1 hora en milisegundos
  },
  showGeoConsole: false,
  activeGeo: false,
  envLabel: ""
};
